module.exports = __webpack_public_path__ + "images/charity4.d7c77af1.svg";